module.exports = __webpack_public_path__ + "img/arrows.1ab8e030.svg";